export default __webpack_public_path__ + "static/media/uy.148e0bfa.svg";